<template>
  <div class="pc-download">
    <div class="mask"></div>
    <img class="bg" src="./images/bg.png" alt="" srcset="" />
    <div class="main">
      <h2>
        We love playing together！
      </h2>
      <p class="content">
        Within every captivating voice resides a fascinating soul. Journeying
        through games,<br />
        conversing about life, and exchanging laughter and moments create truly
        delightful experiences.
      </p>
      <div class="download-item">
        <img
          class="apple btn"
          src="./images/ios.png"
          alt=""
          srcset=""
          @click="jumpAppStore('appleStore')"
        />
        <img
          class="google btn"
          src="./images/google.png"
          srcset=""
          @click="jumpAppStore('google')"
        />
        <img
          class="android btn"
          src="./images/android.png"
          alt=""
          srcset=""
          @click="jumpAppStore('android')"
        />
        <div class="download">
          <img class="scan btn" src="./images/scan.png" alt="" srcset="" />
          <div class="qrcode-box">
            <!-- <img class="qrcode" src="./images/qrcode.png" alt="" srcset="" /> -->
            <figure class="qrcode">
              <qrcode
                :value="appLinkUrl"
                :options="{
                  background: '#fff',
                  margin: 3,
                  color: {
                    light: '#000000',
                    dark: '#ffffff'
                  }
                }"
              >
              </qrcode>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: 'WebDownloadApp',
  components: {
    qrcode: VueQrcode
  },
  props: {},
  data() {
    return {
      appLinkUrl:
        process.env.VUE_APP_ENV == 'test'
          ? 'https://test.nicee.tw/download-app'
          : 'https://nicee.tw/download-app'
    };
  },
  watch: {},
  computed: {
    isPc() {
      return window.innerWidth > 600;
    }
  },
  methods: {
    jumpAppStore(type) {
      this.$util.downloadApp(type);
    }
  },
  created() {
    if (!this.isPc) {
      this.$util.jumpAppStore();
    }
  }
};
</script>
<style lang="scss" scoped>
.pc-download {
  position: relative;
  width: 100% !important;
  height: 100%;
  // background-image: url('./images/bg.png');
  // background-size: cover;
  overflow: auto;
}
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  object-fit: cover;
}
.mask {
  /* Rectangle 113690 */

  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  background: linear-gradient(
    180deg,
    rgba(124, 31, 126, 0.62) 0%,
    rgba(173, 35, 176, 0.24) 100%,
    rgba(173, 35, 176, 0.34) 100%
  );
  z-index: 2;
}
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3;
  line-height: 1.5;
  text-align: center;

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 81px;
    color: #ffffff;
  }
  .content {
    font-weight: 400;
    font-size: 25px;
    text-align: center;
    color: #ffffff;
    padding-top: 50px;
  }
  .download-item {
    padding-top: 50px;
    .btn {
      margin-right: 22px;
      height: 78px;
      width: auto;
      cursor: pointer;
    }
  }
  .download {
    display: inline-block;
    position: relative;

    .qrcode-box {
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translate(-50%, 0);
      display: none;
      border-radius: 20px;
      font-size: 0;
      overflow: hidden;
    }
    &:hover {
      .qrcode-box {
        display: block;
      }
    }
  }
}

@media screen and (max-width: 599px) {
  .main {
    h2 {
      font-weight: 600;
      font-size: 30px;
      line-height: 1.3;
      /* identical to box height, or 100% */
      letter-spacing: -0.04em;
      color: #ffffff;
    }
    .content {
      font-size: 14px;
      line-height: 22px;
      color: #ffffff;
      padding-top: 24px;
    }
    .download-item {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      padding-top: 0;
    }
    .apple,
    .google {
      width: 178px !important;
      // height: auto !important;
      height: 57.37px !important;
      // object-fit: contain !important;
    }
    .download {
      display: none;
    }
    .android  {
      width: 57px;
      height: 57px;
    }
    .apple,.google,.android {
      margin-top: 30px;
    }
  }
}
</style>
